import { logError } from "@lib/logger";

const JUNIP_API = "https://api.juniphq.com/v1/";

async function junipFetch(endpoint) {
  try {
    const result = await fetch(`${JUNIP_API}${endpoint}`, {
      headers: {
        "Junip-Store-Key": process.env.JUNIP_API_KEY,
      },
    }).then((response) => response.json());

    return result;
  } catch (error) {
    logError(error);
    return null;
  }
}
export async function junipProduct(shopifyId) {
  const junipProduct = await junipFetch(
    `products?filter[remote_ids]=${shopifyId}&include=active_traits`
  );

  if (junipProduct) {
    return junipProduct.products[0];
  }

  return null;
}

export async function junipReviews(
  junipProductId,
  after = null,
  size = 20,
  sortField = "created_at",
  sortOrder = "desc"
) {
  let endpoint = `product_reviews?page[size]=${size}&filter[product_ids]=${junipProductId}&include=trait_ratings,customer&sort[field]=${sortField}&sort[order]=${sortOrder}`;
  if (after) {
    endpoint += `&page[after]=${after}`;
  }
  const junipReviews = await junipFetch(endpoint);

  if (junipReviews) {
    return junipReviews;
  }

  return [];
}

export async function addJunipReview(productId) {
  const junipProductInfo = await junipProduct(productId);

  if (junipProductInfo) {
    const junipReviewFormUrl = `https://junip.co/forms/review/product?token=${junipProductInfo.token}`;
    window.location.href = junipReviewFormUrl;
  } else {
    console.error("Failed to fetch Junip product information.");
  }
}
